import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
} from '@/shared/components';
import type { CreateInvoiceBlockRequest, InvoiceBlockResponse } from '@/shared/api';
import { InvoiceBlockFields } from './InvoiceBlockFields';
import { initialBlockForm, toBlockRequest, type InvoiceBlockFormState } from './invoiceBlockForm';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** null = neuer Posten, sonst Bearbeitung. */
  block: InvoiceBlockResponse | null;
  propertyCurrency: string;
  saving: boolean;
  onSubmit: (values: CreateInvoiceBlockRequest) => void;
}

export function InvoiceBlockEditDialog({
  open,
  onOpenChange,
  block,
  propertyCurrency,
  saving,
  onSubmit,
}: Props) {
  const [form, setForm] = useState<InvoiceBlockFormState>(() => initialBlockForm(block));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setForm(initialBlockForm(block));
      setError(null);
    }
  }, [open, block]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const result = toBlockRequest(form);
    if (!result.ok) {
      setError(result.error);
      return;
    }
    onSubmit(result.value);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {block ? 'Wiederkehrenden Posten bearbeiten' : 'Neuer wiederkehrender Posten'}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <DialogBody className="space-y-4">
            <InvoiceBlockFields
              form={form}
              propertyCurrency={propertyCurrency}
              error={error}
              onChange={(patch) => setForm((current) => ({ ...current, ...patch }))}
            />
          </DialogBody>
          <DialogFooter>
            <Button variant="ghost" type="button" onClick={() => onOpenChange(false)}>
              Abbrechen
            </Button>
            <Button variant="brand" type="submit" loading={saving}>
              Speichern
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
